import { Vue, Component } from 'vue-property-decorator'
import { TournamentAPI, TournamentEntity } from '@/api/tournament'
import ServerError from '@/utils/server_error'

@Component
export default class InstantMatchCatalogLogic extends Vue {
  isTournamentCatalogLoading: boolean = false
  page: number = 1
  hasMorePage: boolean = false
  tournamentList: TournamentEntity[] = []
  tournamentListElement!: HTMLDivElement

  async fetchAutomatedTournamentCatalog(
    page: number,
    game: string,
    region: string | null
  ) {
    if (this.isTournamentCatalogLoading) {
      return
    }

    this.isTournamentCatalogLoading = true
    this.page = page
    this.hasMorePage = false
    try {
      const res = await TournamentAPI.getAutomatedTournamentCatalog(
        this.page,
        game,
        region == null ? undefined : [region]
      )
      this.tournamentList = [...this.tournamentList, ...res.data.payload!.items]
      this.hasMorePage = res.data.payload!.hasMorePage
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Landing.SystemErrorMessage'))
      }
      console.error(err)
    } finally {
      this.isTournamentCatalogLoading = false
    }
  }
}
